import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPhoneMaskBrDirective } from './ngx-phone-mask-br.directive';
export class NgxPhoneMaskBrModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  	imports: [
		CommonModule
	],
	declarations: [NgxPhoneMaskBrDirective],
	exports: [NgxPhoneMaskBrDirective]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NgxPhoneMaskBrModule_tsickle_Closure_declarations() {
/** @type {?} */
NgxPhoneMaskBrModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgxPhoneMaskBrModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
